const l = {
  id: "PowerBall",
  name: "Powerball®",
  style: {
    colorPrimary: "#000000",
    doublePlay: "#dc4033",
    extraBall: {
      bg: "#000000",
      color: "#ffffff",
      fontSize: "0.4375rem",
      fontWeight: 700
    }
  }
};
export {
  l as default
};
